import React, { useContext } from "react";
import MechanicsScreenDetails from "../components/Category/MechanicsScreenDetails";
import MechScreenSideBar from "../components/Category/MechScreenSideBar";
import { useParams, Link } from "react-router-dom";
import Footer from "./Layout/Footer";
import { AppContext } from "../context/AppContext";
import axios from "axios";

function Mechanics(props) {
  let params = useParams();
  const { searchedMechanics, reset, setReset, searchedAdverts } =
    useContext(AppContext);
  const [latests, setLatests] = React.useState([]);
  const [search, setSearchs] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const [nextPage, setNextPage] = React.useState(null);
  const [total, settotal] = React.useState(0);
  React.useEffect(() => {
    axios
      .get("https://dashboard.maineautoparts.com/api/mechanics")
      .then((response) => {
        const ads = Array.isArray(response.data.data) ? response.data.data : [];
        setNextPage(response.data.next_page_url);
        settotal(response.data.total);
        setSearchs(ads);
       // ads = searchedAdverts.slice(0, 5);
        setLatests(ads);
      });
    setReset(!reset);
  }, [params]);

  return (
    <div>
      <div className="main-container container">
        <ul className="breadcrumb">
          <li>
            <Link to="/">
              <i className="fa fa-home"></i>
            </Link>
          </li>
          <li>
            <Link to="#">SEARCH</Link>
          </li>
        </ul>

        <div className="row">
          {/*Middle Part Start*/}
          <div id="content" className="col-md-9 col-sm-8">
            <MechanicsScreenDetails
              ads={searchedMechanics.length != 0 ? searchedMechanics : search}
              nextPageUrl={nextPage}
              category="SEARCH"
              total={total}
            />
          </div>
          {/*Side Bar*/}
          <MechScreenSideBar latests={latests} />
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default Mechanics;
